import React from "react";
import { Modal, IconButton } from "@kaena1/mm-ui-components";
import YouTube from "react-youtube";
import "../css/video-player-modal.scss";

interface ModalOverlayProps {
  children?: React.ReactElement;
}

export const ModalOverlay = ({ children }: ModalOverlayProps) => (
  <div className="modalOverlay">
    <IconButton
      className="closeButton"
      icon={
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      }
      fill="#FFF"
      aria-label="Close"
    />
    {children}
  </div>
);

interface VideoPlayerModalProps {
  videoId: string;
  setVideoId: (id: string | null) => void;
}

export const VideoPlayerModal = ({
  videoId,
  setVideoId,
}: VideoPlayerModalProps) => {
  const height =
    window.innerWidth * 0.5625 < window.innerHeight - 100
      ? window.innerWidth * 0.5625
      : window.innerHeight - 100;
  const width = height * 1.7777;
  
  const opts = {
    width: width.toString(),
    height: height.toString(),
    playerVars: {
      autoplay: 1,
      fs: 0,
      controls: 1,
      rel: 0,
      iv_load_policy: 3,
    },
  };

  return (
    <Modal
      isOpen={!!videoId}
      onClose={() => setVideoId(null)}
      className="videoPlayerModal"
      overlay={<ModalOverlay />}
      showCloseButton={false}
    >
      <YouTube videoId={videoId} opts={opts} className="video" />
    </Modal>
  );
};